import useSWR from 'swr';
import { API_GET_IS_DASHBOARD_ENABLED } from '../api/configurationScreenServices';

const fetcher = async () => {
  const res = await API_GET_IS_DASHBOARD_ENABLED();
  if (res?.status !== 200) throw new Error('dashboard config fetch failed');
  return res.data;
};

export const dashboardConfigKey = 'dashboardConfig';

export function useDashboardConfig() {
  return useSWR(dashboardConfigKey, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false
  });
}
